module.exports = "0.6.4";



//////////////////
// WEBPACK FOOTER
// ./~/dagre-d3/lib/version.js
// module id = 1744
// module chunks = 0